import { toBase64 } from '../../../../utils/index.js';
import { BaseWasmQuery } from '../../BaseWasmQuery.js';
export class QueryTradingStrategyContractUserStrategies extends BaseWasmQuery {
    toPayload() {
        const payload = toBase64({
            user_strategy: {
                user: this.params.user,
            },
        });
        return payload;
    }
}
